import { PagePayload } from '@core/interface/core';
import {
  AddSORResponse,
  DeletedSOR,
  SORError,
  SORItem,
  SORResponse,
} from '@core/interface/sor';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const SORActions = createActionGroup({
  source: 'SOR',
  events: {
    'Load SORs': props<PagePayload>(),
    'Load SORs Success': props<SORResponse>(),
    'Load SORs Failure': props<SORError>(),
    'Add Edit SOR': props<SORItem>(),
    'Add SOR Success': props<AddSORResponse>(),
    'Update SOR Success': props<AddSORResponse>(),
    'Add SOR Failure': props<SORError>(),
    'Update SOR Failure': props<SORError>(),
    'Delete SOR': props<{ id: number }>(),
    'Delete SOR Success': props<DeletedSOR>(),
    'Delete SOR Failure': props<SORError>(),
    'Reset Delete Status': emptyProps(),
    'Reset SORs': emptyProps(),
  },
});
